import React from "react";
import { ShieldCheck, Truck, Map, Headphones } from "lucide-react";

const FEATURES = [
  {
    icon: Truck,
    title: "On-Site Fueling",
    desc: "We bring premium diesel and gasoline directly to your fleet — no fuel island trips, no downtime.",
  },
  {
    icon: Map,
    title: "34 States Covered",
    desc: "From Texas to coast-to-coast — including dyed diesel for off-road use and bulk delivery.",
  },
  {
    icon: ShieldCheck,
    title: "Trusted Since 1988",
    desc: "Reliable, accurate, and federally compliant fuel distribution for commercial fleets.",
  },
  {
    icon: Headphones,
    title: "24/7 Dispatch",
    desc: "Our team is on call around the clock to keep your trucks moving.",
  },
];

export const InfoSection = () => {
  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20"
      data-testid="info-section"
    >
      <div className="max-w-2xl mb-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="gold-bar" />
          <span className="text-[#63499d] text-xs font-bold tracking-[0.18em] uppercase">
            Why Ricochet
          </span>
        </div>
        <h2 className="font-display font-bold text-3xl sm:text-4xl text-[#404041] leading-tight">
          More than fuel.{" "}
          <span className="text-[#63499d]">A competitive advantage.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {FEATURES.map(({ icon: Icon, title, desc }, idx) => (
          <div
            key={title}
            className="result-card bg-white border border-slate-200 rounded-2xl p-6"
            data-testid={`info-feature-${idx}`}
          >
            <div className="w-11 h-11 rounded-xl bg-[#63499d]/10 text-[#63499d] grid place-items-center mb-4">
              <Icon className="w-5 h-5" strokeWidth={2.25} />
            </div>
            <h3 className="font-display font-bold text-lg text-[#404041] mb-1.5">
              {title}
            </h3>
            <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
